import { CustomerTeamMemberType } from '~/generated/types'
import * as OWUtils from '~/utils/OWUtils'
import React from 'react'
import { urlForCustomer } from '~/utils/PlaceManager'
import { CUSTOMER_PILL_ID_PREFIX } from '~/utils/MentionUtils'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type CustomerPillProps = {
    customerMembership: CustomerTeamMemberType
    editing?: boolean
}

export const CustomerPill = ({ customerMembership, editing }: CustomerPillProps) => {
    const imgSrc = customerMembership.customer.logo || OWUtils.staticPath('orgwiki/img/default-customer-photo.svg')
    const crownSrc = OWUtils.staticPath('orgwiki/img/icon-owner@2x.png')
    const showCrown =
        customerMembership.isAccountLead ||
        customerMembership.isRdLead ||
        customerMembership.isCommercialLead ||
        customerMembership.isExecutiveSponsor

    // need to be able to manually control the classname in the editor
    const tooltipOverlay = (
        <Tooltip id={'tooltip'} className={'lead-role-tooltip crown-tooltip'}>
            {customerMembership.isAccountLead ? <p>Account Lead</p> : ''}
            {customerMembership.isCommercialLead ? <p>Commercial Lead</p> : ''}
            {customerMembership.isExecutiveSponsor ? <p>Executive Sponsor</p> : ''}
            {customerMembership.isRdLead ? <p>R&D and Quality Lead</p> : ''}
        </Tooltip>
    )

    const contents = (
        <span
            className={`customer-pill-wrapper ${editing && 'editing'} ${showCrown && 'show-crown'}`}
            id={`${CUSTOMER_PILL_ID_PREFIX}${customerMembership.customerId}`}
        >
            {/*We use the classname "customer-pill-component" to prevent clicking causing a re-query in atwho.js*/}
            <span className={'profile-customer-pill customer-pill-component'} contentEditable={false}>
                <span className={'left-items customer-pill-component'}>
                    <img
                        alt={`${customerMembership.customer.name} logo`}
                        className={'customer-name-photo customer-pill-component'}
                        src={imgSrc}
                    />
                    <span className={'customer-name customer-pill-component'}>{customerMembership.customer.name}</span>
                </span>
                <span className={'right-items customer-pill-component'}>
                    <OverlayTrigger overlay={tooltipOverlay} placement={'bottom'}>
                        <img
                            alt={'crown'}
                            className={'lead-crown customer-pill-component'}
                            src={crownSrc}
                            data-testid={showCrown ? 'lead-crown' : ''}
                        />
                    </OverlayTrigger>
                    {editing && (
                        // The delete action is controlled by the parent because we render the pill as static HTML as mentions inside of the editor.
                        <button data-testid="delete-button" className="delete-pill-button deleteRow" />
                    )}
                </span>
            </span>
        </span>
    )

    if (editing) {
        return contents
    }

    return <a href={urlForCustomer({ customerId: customerMembership.customerId })}>{contents}</a>
}
